import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// Standard shadcn helper — composes Tailwind classes with conflict
// resolution. Every component uses this for variant styling so the
// caller's `className` override wins over the default.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
